import Vue from 'vue'
const SugarDate = require('sugar/date')
const SugarLoc = require('sugar/locales')
//- Filters

Vue.filter('datetime', value => {
  if (!value) {
    return ''
  }
  const date = new Date(value)
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() < 9 ? '0' : '') +
    (date.getMonth() + 1) +
    '-' +
    (date.getDate() < 10 ? '0' : '') +
    date.getDate() +
    ' ' +
    (date.getHours() < 9 ? '0' : '') + 
    date.getHours() + 
    ':' + 
    (date.getMinutes() < 9 ? '0' : '') + 
    date.getMinutes()
  )
})

Vue.filter('date', value => {
  if (!value) {
    return ''
  }
  const date = new Date(value)
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() < 9 ? '0' : '') +
    (date.getMonth() + 1) +
    '-' +
    (date.getDate() < 10 ? '0' : '') +
    date.getDate()
  )
})

Vue.filter('time', value => {
  if (!value) {
    return '-'
  }
  const date = new Date(value)
  return (
    (date.getHours() < 9 ? '0' : '') + date.getHours() + ':' + (date.getMinutes() < 9 ? '0' : '') + date.getMinutes()
  )
})

Vue.filter('ago', value => {
  SugarLoc.Date.setLocale('sv')
  return SugarDate.Date(value).relative()
})
//- Filters
//To get the mobile format: nnn nnn nn nn
Vue.filter('phoneNo', value => {
  var ret = ''
  var val = ''
  var c = 0
  val = value.replace('-', '')
  if (val.length > 2) {
    ret += val.substring(c, c + 3) + ' '
    c += 3
  }
  if (val.substring(0, 1) == '+' && val.length > 5) {
    ret += val.substring(c, c + 3) + ' '
    c += 3
  }
  var i
  for (i = c; i <= val.length; i++) {
    if (i == 3 && val.length >= i) {
      ret += val.substring(i, i + 1)
      i++
    }
    if (val.length > i) {
      ret += val.substring(i, i + 1)
    }
    if (val.length > i + 1) {
      ret += val.substring(i + 1, i + 2) + ' '
      i++
    }
  }
  if (ret.substring(ret.length - 1, ret.length) == ' ') {
    //remove the last space
    ret = ret.substring(0, ret.length - 1)
  }
  return ret
})
Vue.filter('formatZip', value => {  
  if (!value || value === 'undefined' || value === null) {
    return ''
  }
  
  var ret = value.replace(' ', '')
  try {
    return ret.substr(0, 3) + ' ' + ret.substr(3, 2)
  } catch {
    return ret
  }
})
Vue.filter('capitalize', value => {  
  if (!value || value === 'undefined' || value === null) {
    return ''
  }
    
  try {
    return value.charAt(0).toUpperCase() + value.slice(1);
    
  } catch {
    return 'nej'
  }
})
Vue.filter('formatPnr', value => {
  if (!value) {
    return ''
  }
  try {
    return value.substr(0, 8) + '-' + value.substr(8, 4)
  } catch {
    return value
  }
})

Vue.filter('formatSecretPnr', value => {
  if (!value) {
    return ''
  }
  try {
    return value.substr(0, 8) + '-****'
  } catch {
    return value
  }
})
//- Filters
Vue.filter('fullName', value => {
  if (!value) return ''
  return value.firstName + ' ' + value.lastName
})
Vue.filter('initials', value => {
  if (!value) return ''

  let i1 = value && value.firstName ? value.firstName.charAt(0) : '_'
  let i2 = value && value.lastName ? value.lastName.charAt(0) : '_'
  return i1 + i2
})
Vue.filter('filterCredit', c => {
  if (!c) return ''
  if (c && Number(c) >= 0) return c + " poäng";
  return "";
})

Vue.filter('currency', value => {
  return Number(value).toLocaleString('sv-SE');
});

Vue.filter('validCurrency', value => {
  if (Number(value) > 0) return Number(value).toLocaleString('sv-SE');
  return null;
});

Vue.filter('withCurrencyCode', value => {
  return value ? `${value} kr` : value;
});

Vue.filter('exclFee', value => {
  return Math.floor(value / 1.25)
});

Vue.filter('postalZipFormat', value => {
  //console.log('value :>> ', value);
  return value ? value.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/, '') : ''

});
